"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _CreateStoreComponent = _interopRequireDefault(require("../components/CreateStoreComponent"));
var _Services = require("../common_features/utility/Services");
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _reactRedux = require("react-redux");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));
var _helper = require("../common_features/utility/helper");
var _heic2any = _interopRequireDefault(require("heic2any"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CreateStore = () => {
  const windowLayout = (0, _helper.getPlatformType)();
  let storeImageId = "";
  const videoRef = (0, _react.useRef)(null);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [sNameCS, setSNameCS] = (0, _react.useState)('');
  const [countryCS, setCountryCS] = (0, _react.useState)({});
  const [countriesCS, setCountriesCS] = (0, _react.useState)([]);
  const [zipcodeCS, setZipcodeCS] = (0, _react.useState)('');
  const [isZipCodeValidCS, setIsZipCodeValidCS] = (0, _react.useState)(false);
  const [address1CS, setAddress1CS] = (0, _react.useState)('');
  const [address2CS, setAddress2CS] = (0, _react.useState)('');
  const [cityCS, setCityCS] = (0, _react.useState)('');
  const [stateCS, setStateCS] = (0, _react.useState)('');
  const [phoneNoCS, setPhoneNoCS] = (0, _react.useState)('');
  const [titleCS, setTitleCS] = (0, _react.useState)('United States of America');
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [duplicateStore, setDuplicateStore] = (0, _react.useState)(false);
  const [displayPhotosModal, setDisplayPhotosModal] = (0, _react.useState)(false);
  const [isOneSelected, setOneSelected] = (0, _react.useState)(!(0, _helper.getPlatformType)());
  const [isTwoSelected, setTwoSelected] = (0, _react.useState)(_helper.getPlatformType);
  const [currentImage, setCurrentImage] = (0, _react.useState)('');
  const [imagePath, setImagePath] = (0, _react.useState)('');
  const [modalText, setModalText] = (0, _react.useState)({
    duplicateModalVariant: "",
    modalHeaderText: "",
    modalDetailText: "",
    positiveActionButtonTitle: "",
    modalHeaderTextStyle: {}
  });
  const dispatch = (0, _reactRedux.useDispatch)();
  const options = {
    maxSizeMB: 6,
    maxWidthOrHeight: 1920,
    useWebWorker: true
  };
  const warningStoreModalData = {
    duplicateModalVariant: modalText.duplicateModalVariant,
    displayModal: true,
    modalHeaderIcon: false,
    displayCrossIcon: true,
    modalHeaderText: modalText.modalHeaderText,
    modalHeaderTextStyle: modalText.modalHeaderTextStyle,
    modalDetailText: modalText.modalDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: modalText.positiveActionButtonTitle
  };
  (0, _react.useEffect)(() => {
    (0, _Services.getCountryList)().then(res => {
      if (res.success) {
        const countries = res.data ? res.data.map(country => {
          return {
            code: country.code,
            title: country.name,
            key: country.name + country.code
          };
        }) : [];
        setCountriesCS(countries);
      }
    });
  }, []);
  const checkformsInput = () => {
    return sNameCS && zipcodeCS && address1CS && cityCS && stateCS && phoneNoCS.length > 5 || false;
  };
  const addNewStore = async () => {
    let address = {
      "address1": address1CS,
      "address2": address2CS,
      "city": cityCS,
      "state": stateCS,
      "colony": "",
      "postalcode": zipcodeCS,
      "country": 'US'
    };
    const requestBody = {
      name: sNameCS,
      address: JSON.stringify(address),
      phoneNo: phoneNoCS,
      imageSubPath: imagePath
    };
    setIsLoading(true);
    await (0, _Services.createNewStore)(requestBody).then(apiResp => {
      if (apiResp && apiResp.success === true) {
        setIsLoading(false);
        dispatch((0, _storesReducer.currentStore)(apiResp));
        navigate(_RoutePath.default.manageStore.useLink);
      } else {
        setModalText({
          duplicateModalVariant: "warning-modal",
          modalHeaderText: "Address already exists",
          modalDetailText: "The address you have entered already exists. Please try to add a different address for your store.",
          positiveActionButtonTitle: "OK",
          modalHeaderTextStyle: {
            fontSize: 16,
            color: "#E00932",
            fontWeight: 600,
            lineHeight: "22px",
            marginTop: "14px"
          }
        });
        setDuplicateStore(true);
      }
      setIsLoading(false);
    }).catch(error => {
      setIsLoading(false);
    });
  };
  const onZipcodeBlur = e => {
    var _countriesCS$;
    (0, _Services.GetCityState)({
      zipcode: e.target.value,
      country: countriesCS === null || countriesCS === void 0 ? void 0 : (_countriesCS$ = countriesCS[0]) === null || _countriesCS$ === void 0 ? void 0 : _countriesCS$.code
    }).then(data => {
      if (data.error) {
        setIsZipCodeValidCS(true);
      } else {
        setIsZipCodeValidCS(false);
        const City = data.response.results[0].address_components[1].long_name;
        const State = data.response.results[0].address_components.filter(element => {
          return element.types.includes("administrative_area_level_1");
        })[0].short_name;
        setCityCS(City);
        setStateCS(State);
      }
    });
  };
  const onChangeZipHandler = async function (evt, InputName) {
    if (!evt.target.onblur) {
      evt.target.onblur = onZipcodeBlur;
    }
  };
  const removeDuplicateStoreModal = () => {
    setDuplicateStore(false);
  };
  const handleFileUpload = async img => {
    if (!storeImageId) {
      storeImageId = (0, _helper.generateUuid)();
    }
    const base64EncodedImage = await (0, _helper.convertToBase64)(img);
    let imageSubPath = "storeImageId/".concat(storeImageId, ".png");
    await (0, _Services.storeImageUpload)(base64EncodedImage, imageSubPath).then(data => {
      if (JSON.parse(JSON.stringify(data)).name === "Error") {
        setImagePath("");
        throw new Error("Image Upload Failed");
      } else {
        setImagePath(imageSubPath);
        const imageUrl = URL.createObjectURL(img);
        setCurrentImage(imageUrl);
      }
    }).catch(e => {
      setModalText({
        duplicateModalVariant: "warning-modal",
        modalHeaderText: "Oops!",
        modalDetailText: "Upload failed. Please try again.",
        positiveActionButtonTitle: "OK",
        modalHeaderTextStyle: {
          fontSize: 16,
          color: "#E00932",
          fontWeight: 600,
          lineHeight: "22px",
          marginTop: "14px"
        }
      });
      setDuplicateStore(true);
    });
  };
  const handleImageInfoIcon = () => {
    setModalText({
      duplicateModalVariant: "info-icon-modal",
      modalHeaderText: "Info",
      modalDetailText: "Only one Image can be uploaded",
      positiveActionButtonTitle: "OK"
    });
    setDuplicateStore(true);
  };
  const handleImageUpload = () => {
    setDisplayPhotosModal(true);
  };
  const compressFileAndUpload = async imageFile => {
    let compressedFile = "";
    try {
      compressedFile = await (0, _browserImageCompression.default)(imageFile, options);
    } catch (e) {}
    await handleFileUpload(compressedFile);
    setIsLoading(false);
  };
  const handleFileChange = async event => {
    setIsLoading(true);
    setDisplayPhotosModal(false);
    if (event.target.files.length > 1) {
      setModalText({
        duplicateModalVariant: "info-icon-modal",
        modalHeaderText: "Info",
        modalDetailText: "Only one Image can be uploaded",
        positiveActionButtonTitle: "OK"
      });
      setDuplicateStore(true);
      setIsLoading(false);
    } else {
      const imageFile = event.target.files[0];
      if (event.target.files[0] && event.target.files[0].name.includes(".heic") && event.target.files[0].name.lastIndexOf(".heic") === event.target.files[0].name.length - 5) {
        let blobURL = URL.createObjectURL(event.target.files[0]);
        let blobRes = await fetch(blobURL);
        let blob = await blobRes.blob();
        (0, _heic2any.default)({
          blob,
          toType: "image/jpeg"
        }).then(async imageData => {
          await compressFileAndUpload(imageData);
        }).catch(e => {});
      } else {
        await compressFileAndUpload(imageFile);
      }
    }
    // FOR BUG IN CHROME
    event.target.value = "";
  };
  const onModalCancel = () => {
    setTwoSelected((0, _helper.getPlatformType)());
    setOneSelected(!(0, _helper.getPlatformType)());
    setDisplayPhotosModal(false);
  };
  const onOptionSelect = key => {
    if (key === 1) {
      setOneSelected(true);
      setTwoSelected(false);
    } else {
      setTwoSelected(true);
      setOneSelected(false);
    }
  };
  const handlePhotoRemove = () => {
    setCurrentImage('');
    setImagePath("");
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: " "
  }, /*#__PURE__*/_react.default.createElement(_CreateStoreComponent.default, {
    isLoading: isLoading,
    sName: sNameCS,
    country: countryCS,
    zipcode: zipcodeCS,
    isZipCodeValid: isZipCodeValidCS,
    address1: address1CS,
    address2: address2CS,
    city: cityCS,
    state: stateCS,
    phoneNo: phoneNoCS,
    setSName: e => {
      setSNameCS(e.target.value);
    },
    setCountry: e => {
      setTitleCS(e.title);
      setCountryCS(e);
    },
    setZipcode: e => {
      setZipcodeCS(e.target.value);
      onChangeZipHandler(e, 'zipcode');
    },
    setIsZipCodeValid: setIsZipCodeValidCS,
    countries: countriesCS,
    setAddress1: e => {
      setAddress1CS(e.target.value);
    },
    setAddress2: e => {
      setAddress2CS(e.target.value);
    },
    setCity: e => {
      setCityCS(e.target.value);
    },
    setState: e => {
      setStateCS(e.target.value);
    },
    setPhoneNo: setPhoneNoCS,
    navigate: () => {
      navigate(_RoutePath.default.manageStore.useLink);
    },
    isErrorFree: true,
    title: titleCS,
    onChangeHandler: onChangeZipHandler,
    addNewStore: addNewStore,
    isFormValid: checkformsInput,
    notificationsText: '',
    isValidPhoneNumber: (phoneNoCS === null || phoneNoCS === void 0 ? void 0 : phoneNoCS.length) > 10 || (phoneNoCS === null || phoneNoCS === void 0 ? void 0 : phoneNoCS.length) === 0 || (phoneNoCS === null || phoneNoCS === void 0 ? void 0 : phoneNoCS.length) === 1 ? true : false,
    numberInvalidText: (phoneNoCS === null || phoneNoCS === void 0 ? void 0 : phoneNoCS.length) > 10 || (phoneNoCS === null || phoneNoCS === void 0 ? void 0 : phoneNoCS.length) === 0 || (phoneNoCS === null || phoneNoCS === void 0 ? void 0 : phoneNoCS.length) === 1 ? "This will be used for SMS notifications" : "Please enter a valid phone number",
    modalText: warningStoreModalData,
    isModalLoading: isLoading,
    duplicateModal: duplicateStore,
    handleResendInviteModal: removeDuplicateStoreModal,
    imageUploadHeaderText: "Add image of your store front.",
    imageUploadInfoIcon: _images.default.infoIcon.default,
    imageUplaodInfoIconHandle: handleImageInfoIcon,
    handleImageUpload: handleImageUpload,
    displayPhotosModal: displayPhotosModal,
    continuePress: true,
    checkmark: _images.default.checkmark.default,
    camDivStyle: {
      backgroundColor: '#006E96',
      justifyContent: 'center',
      width: '100%',
      height: '45px',
      borderRadius: 10,
      color: '#fff '
    },
    camLabelStyle: {
      width: '100%',
      height: '45px',
      fontWeight: 700,
      marginTop: '10px',
      textAlign: "center"
    },
    hideImageButton: {
      width: '100%',
      height: '45px',
      display: 'none'
    },
    checkmarkStyle: {
      marginLeft: '303px',
      marginTop: '-40px'
    },
    videoRef: videoRef,
    saveText: 'Continue',
    handleFileChange: handleFileChange,
    cancelText: "Cancel",
    onModalCancel: onModalCancel,
    isOneSelected: isOneSelected,
    isTwoSelected: isTwoSelected,
    onOptionSelect: onOptionSelect,
    currentImage: currentImage,
    handlePhotoRemove: handlePhotoRemove,
    windowLayout: windowLayout
  })));
};
var _default = exports.default = CreateStore;